import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('setCategoryNameOnNewCategory')(function setCategoryNameOnNewCategory(categoryName) {
    store.newCategory.Name = categoryName;
});
//# sourceMappingURL=setCategoryNameOnNewCategory.js.map